import DocumentEditPage, { DocumentEditConfig } from 'src/document-editor/edit/DocumentEditPage';

const config: DocumentEditConfig = {
  pageType: 'meeting-agenda-edit',
  title: 'Meeting Agenda',
  documentTypePath: 'meeting-agendas',
  documentLabel: 'meeting agenda',
};

export default function MeetingAgendaEditPage() {
  return <DocumentEditPage config={config} />;
}
